import { render, staticRenderFns } from "./NextTierMessage.vue?vue&type=template&id=09567591&scoped=true"
import script from "./NextTierMessage.vue?vue&type=script&lang=js"
export * from "./NextTierMessage.vue?vue&type=script&lang=js"
import style0 from "./NextTierMessage.vue?vue&type=style&index=0&id=09567591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09567591",
  null
  
)

export default component.exports